/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
export const UserConfig = core.serialization.object({
    email: core.serialization.string(),
    name: core.serialization.string(),
    accountId: AccountId,
});
